/**************************************************
 * Nombre:       Home_Varietales
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid} from "@mui/material";
import Camino from "./SubComponentes/Camino";
import Catalogo from "./SubComponentes/Catalogo";
import fondo from '../../../Recursos/fondo_catalogo.svg'
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";
import SolicitaMuestrario from "./SubComponentes/SolicitaMuestrario";

const Home_Varietales = () => {
    const {sCell} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                background: `url(${fondo})`,
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'cover',
                backgroundPosition: 'center center',
                pb: 18
            }}
        >

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3, color: '#fff', mt: 8}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                        spacing={sCell ? 0 : 4}
                    >

                        <Grid container size={{xs: 12, sm: 5, md: 4}} sx={{justifyContent: 'flex-start'}}>
                            <Camino/>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 7, md: 8}}
                              sx={{justifyContent: 'flex-start', mt: sCell ? 0 : 0}}>
                            <Catalogo/>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 4}}>
                            <SolicitaMuestrario/>
                        </Grid>

                    </Grid>
                </Grid>

            </Grid>

        </Grid>
    )

}
export default Home_Varietales